import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {firestoreConnect, withFirestore, populate} from "react-redux-firebase";
import {UserIsAuthenticated} from "../../utils/AuthManager";
import {connect} from "react-redux";
import {ACCEPTED, DECLINED, WAITING_FOR_DECISION} from "../../utils/employeeStatus";
import withCompanyManagerHOC from "../../components/auth/CompanyManagerHOC";
import {BackgroundDiv} from "../../components/Containers";
import Navbar from "../../components/Navbar";
import {COMPANY_DB_PATH, EMPLOYEE_DB_PATH} from "../../constants/DB_PATHS";
import {acceptUserToCompany, declineUserFromCompany, exitUserFromCompany} from "../../utils/AuthFunctions";
import EmployeeListItem from "../../components/EmployeeListItem";

class EmployeeRequest extends Component {
    render() {
        console.log(this.props)
        const {users} = this.props
        return (
            <div>
                <BackgroundDiv/>
                <h2>Employee Requests</h2>
                {users && users.length !== 0 ?
                    Object.entries(users).map((e, i) => {
                        let user = e[1]
                        if (user.employeeStatus === WAITING_FOR_DECISION) {
                            return (
                                /*<div key={i}>
                                    {user.firstN} {user.lastN}
                                    <button onClick={async () => {
                                        await acceptUserToCompany(
                                            this.props.firestore,
                                            user.id,
                                            this.props.auth.uid,
                                        )

                                    }}>Accept
                                    </button>
                                    <button onClick={async () => {
                                        await declineUserFromCompany(
                                            this.props.firestore,
                                            user.id
                                        )

                                    }}>Decline
                                    </button>
                                </div>*/
                                <EmployeeListItem
                                    key={i}
                                    user={user}
                                    status={WAITING_FOR_DECISION}
                                    declineFn={async ()=>{
                                        await declineUserFromCompany(
                                            this.props.firestore,
                                            user.id
                                        )
                                    }}
                                    acceptFn={async () => {
                                        await acceptUserToCompany(
                                            this.props.firestore,
                                            user.id,
                                            this.props.auth.uid,
                                        )

                                    }}

                                />
                            )
                        }
                    })
                    :
                    null
                }
                <h2>Accepted</h2>
                {users && users.length !== 0 ?
                    Object.entries(users).map((e, i) => {
                        let user = e[1]
                        console.log(e)
                        if (user.employeeStatus === ACCEPTED) {
                            return (
                                /*<div key={i}>
                                    {user.firstN} {user.lastN}
                                    <button onClick={async () => {
                                        /!*this.props.firestore.collection('users').doc(user.id).update({
                                            companyId: '',
                                            employeeStatus: DECLINED,
                                        })
                                        this.props.firestore.collection(COMPANY_DB_PATH)
                                            .doc(this.props.auth.uid).update({
                                            employees: this.props.firebase.firestore
                                                .FieldValue.arrayRemove(user.id),
                                            firedEmployees: this.props.firebase.firestore
                                                .FieldValue.arrayUnion(user.id),
                                        })
                                        this.props.firestore
                                            .collection(COMPANY_DB_PATH)
                                            .doc(this.props.auth.uid)
                                            .collection('employees')
                                            .doc(user.id).update({
                                            fireDate: new Date(),
                                            status: DECLINED
                                        })
                                        this.props.firestore.collection(EMPLOYEE_DB_PATH)
                                            .doc(user.id).update({
                                                fireDate: new Date(),
                                                employeeStatus: DECLINED,
                                                employeeCompanyNameId: '',
                                                employeeCompanyName: '',
                                            })
*!/
                                        await exitUserFromCompany(
                                            this.props.firestore,
                                            user.id,
                                            this.props.auth.uid,
                                            this.props.firebase,
                                        )

                                    }}>Fire
                                    </button>
                                </div>*/
                                <EmployeeListItem
                                    key={i}
                                    user={user}
                                    status={ACCEPTED}
                                    fireFn={async()=>{
                                        await exitUserFromCompany(
                                            this.props.firestore,
                                            user.id,
                                            this.props.auth.uid,
                                            this.props.firebase,
                                        )
                                    }}
                                />
                            )
                        }
                    })
                    :
                    <div>no user</div>
                }


            </div>
        );
    }
}

export default compose(
    withRouter,
    withFirestore,
    UserIsAuthenticated,
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile
        })
    ),
    connect((state, props) => ({
        users: state.firestore.ordered.users
    })),
    firestoreConnect(props => {
            return [
                {
                    collection: 'users',
                    where: [
                        ['role', '==', 'employee'],
                        ['companyId', '==', props.auth.uid],
                    ]
                },
            ]
        }
    ),
    withCompanyManagerHOC,
)(EmployeeRequest);